module.exports = __webpack_public_path__ + "img/edit-item.378e2668.svg";